import { gql } from "@apollo/client";

export const GENERATE_BAU = gql`
  query GenerateBauBudget($input: MMMGenerateBauBudgetInput!) {
    me {
      mmm {
        generateBauBudget(input: $input) {
          id
          is_blessed
          client_setting_id
          pipeline_run_metadata_id
          data {
            weekly_data {
              start_date
              end_date
              spend_data {
                spend
                data_column_name
              }
              summary_data {
                kpi_data
                spend
              }
            }
            aggregated_data {
              spend_data {
                spend
                data_column_name
              }
              summary_data {
                kpi_data
                spend
              }
            }
          }
          name
          is_custom
          is_adopted
          create_budget_recommendations_metadata
        }
      }
    }
  }
`;
